// extracted by mini-css-extract-plugin
module.exports = {"page-container":"page-container-8daddcfbcec8c250d24323496892c1c3"};